module.exports = __webpack_public_path__ + "img/cards-box-bg-mob.c6e7fe38.png";